export const SHOKZ_CHARGING_ITEM_TYPE = {
  BOX: 1,
  NORMAL: 2
} as const

export const SHOKZ_FEE_TYPE = {
  OCEAN_FREIGHT: 'OCEAN_FREIGHT',
  AIR_FREIGHT: 'AIR_FREIGHT',
  PRE_PORT_FEE: 'PRE_PORT_FEE',
  POL_FEE: 'POL_FEE',
  POD_FEE: 'POD_FEE',
  LAST_MILE_FEE: 'LAST_MILE_FEE',
  PRE_PORT_SURCHARGE: 'PRE_PORT_SURCHARGE',
  LAST_MILE_SURCHARGE: 'LAST_MILE_SURCHARGE',
  OTHER_FEE: 'OTHER_FEE',
  POTENTIAL_FEE: 'POTENTIAL_FEE'
} as const

/** 韶音报价方案服务类型。 */
export const SHOKZ_SERVICE_TYPE = {
  SEA_FCL: 'SEA_FCL',
  SEA_LCL: 'SEA_LCL',
  RORO: 'RORO',
  BREAK_BULK: 'BREAK_BULK',
  LOOSE_CARGO: 'LOOSE_CARGO',
  FULL_PALLET: 'FULL_PALLET',
  FULL_CABIN: 'FULL_CABIN',
  CHARTER: 'CHARTER',
  PRE_PORT: 'PRE_PORT',
  LAST_MILE: 'LAST_MILE'
} as const

export type ShokzServiceType = typeof SHOKZ_SERVICE_TYPE[keyof typeof SHOKZ_SERVICE_TYPE]

/** 服务类型对应的国际化文案键，页面不得直接展示接口枚举代码。 */
export const SHOKZ_SERVICE_TYPE_LABEL_KEY: Record<ShokzServiceType, string> = {
  [SHOKZ_SERVICE_TYPE.SEA_FCL]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.seaFcl',
  [SHOKZ_SERVICE_TYPE.SEA_LCL]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.seaLcl',
  [SHOKZ_SERVICE_TYPE.RORO]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.roro',
  [SHOKZ_SERVICE_TYPE.BREAK_BULK]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.breakBulk',
  [SHOKZ_SERVICE_TYPE.LOOSE_CARGO]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.looseCargo',
  [SHOKZ_SERVICE_TYPE.FULL_PALLET]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.fullPallet',
  [SHOKZ_SERVICE_TYPE.FULL_CABIN]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.fullCabin',
  [SHOKZ_SERVICE_TYPE.CHARTER]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.charter',
  [SHOKZ_SERVICE_TYPE.PRE_PORT]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.prePort',
  [SHOKZ_SERVICE_TYPE.LAST_MILE]: 'quotation.supplierQuotationDetail.serviceFields.serviceTypes.lastMile'
}
